export const shouldHighlightAPR = (apr: string | number | undefined) => {
  const value = Number(apr);

  return Number.isFinite(value) && value >= 0.01;
};

export const shouldHighlightTokenAmount = (amount: string | undefined) => {
  try {
    return BigInt(amount || '0') > BigInt(0);
  } catch {
    return false;
  }
};
